/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import CouponItem from '../../components/coupon/CouponItem';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

class MyCouponList extends Component {
  state = {};
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getData = (gotoPage) => {
    const { _getData } = this.props.childProps;
    _getData(gotoPage);
  };
  _renderPage = () => {
    const { gotoPage, con } = this.state;

    const dataPerPage = isMobile ? 5 : 10; //한페이지에 보여질 갯수
    let pageCount;
    pageCount = dataPerPage;
    const pageNumbers = [];

    const totalPage = Math.ceil(con / dataPerPage); //총페이지수

    const pageGroup = Math.ceil(gotoPage / pageCount); //페이지 그룹
    let last = pageGroup * pageCount;

    if (last > totalPage) {
      last = totalPage;
    }

    let first = last - (pageCount - 1); //화면에 보여질 첫번째 페이지 번호

    const next = last + 1;
    // const prev = first - 1;

    if (totalPage < 1) {
      first = last;
    }

    if (first > pageCount) {
    } else {
    }

    if (next > pageCount && next < totalPage) {
    } else {
    }

    for (let j = first; j <= last; j++) {
      pageNumbers.push(j);
    }

    const list = pageNumbers.map((num, index) => {
      return (
        <span
          key={index}
          style={{ cursor: 'pointer' }}
          onClick={() => this._getData(num)}
          className={gotoPage === num ? 'on' : null}
        >
          {num}
        </span>
        /*<a href="#" className={gotoPage === num ? "active" : null } onClick={()=>this._page(num)} key={index}>{num}</a>*/
      );
    });

    return (
      <Fragment>
        {first > pageCount ? (
          <span onClick={this._onPrev}>이전</span>
        ) : (
          <span style={{ backgroundColor: '#000' }}></span>
        )}
        {list}
        {next > pageCount && next < totalPage ? (
          <span onClick={this._onNext}>다음</span>
        ) : (
          <span style={{ backgroundColor: '#000' }}></span>
        )}
      </Fragment>
    );
  };

  _onPrev = () => {
    const { gotoPage } = this.state;
    // const { eventIdx } = this.props.childProps;
    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn('페이지의 처음입니다.');
    } else {
      this._getData(gotoPage - 1);
    }
  };
  _onNext = () => {
    const { gotoPage, pageCount } = this.state;

    if (gotoPage + 1 >= pageCount) {
      toast.warn('페이지의 마지막입니다.');
      //alert('페이지의 마지막입니다.')
    } else {
      this._getData(gotoPage + 1);
    }
  };

  _renderItem = () => {
    const { dataList, _getData } = this.props.childProps;
    const list = dataList.map((item, index) => {
      return (
        <CouponItem
          key={index}
          couponNo={item.couponNo}
          couponPartName={item.couponPartName}
          couponGubun={item.couponGubun}
          limitDay={item.limitDay}
          startDate={item.startDate}
          endDate={item.endDate}
          _getData={_getData}
        />
      );
    });

    return list;
  };

  render() {
    // const { tabIndex } = this.props.childProps;
    const { dataList } = this.props.childProps;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="list_wrap coupon">
          <div className="listHead">
            유효기간이 지난 쿠폰은 재발행 되지 않으니 유효기간 내에 사용해
            주시기 바랍니다.
          </div>
          <div className="list">
            {dataList ? (
              this._renderItem()
            ) : (
              <ul>
                <li className="coupon">
                  <div className="coupon_txt">
                    <img src={imgUrl + '/img/mypage/coupon_logo.png'} />
                    <p>정기결제 멤버십</p>
                  </div>
                </li>
                <li className="info">
                  <div className="name">등록된 쿠폰이 존재하지 않습니다</div>
                  <div className="con"></div>
                </li>
              </ul>
            )}
          </div>
          <div className="page_no">{dataList ? this._renderPage() : null}</div>
        </div>

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(MyCouponList));
